import './style/index.less';
import RegisterForm from './RegisterForm';

export * from './RegisterForm';

export default RegisterForm;
